import { Container } from "../SignUp/partials/Container";
import { Button, Stack, Fade, FormHelperText } from "@mui/material";
import { Header } from "../SignUp/partials/Header";
import { Navigate } from "react-router-dom";
import { CircularProgress, TextualDivider } from "../../components";
import { SubmitButton } from "../SignUp/partials/SubmitButton";
import { useEmailVerificationPageFacade } from "./lib/useEmailVerificationPageFacade";

const EmailVerification = () => {
  const {
    token,
    email,
    status,
    errors,
    resendingEmail,
    resendEmail,
    navigateToHome,
  } = useEmailVerificationPageFacade();

  return !token || !email ? (
    <Navigate to="/login" replace />
  ) : (
    <Container>
      <Fade in={status === "idle"} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={status === "idle" ? "flex" : "none"}
        >
          <CircularProgress size="lg" sx={{ mb: 3 }} />
          <Header
            disableCompanyIdentity
            title="Email verification"
            subtitle="Please don't leave this page, we are verifying your email"
          />
        </Stack>
      </Fade>
      <Fade in={status === "error"} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={status === "error" ? "flex" : "none"}
        >
          <Header
            disableCompanyIdentity
            title="Email verification failed"
            subtitle="Please resend the verification email and try again"
          />
          <SubmitButton
            onClick={() => resendEmail(email)}
            loading={resendingEmail}
          >
            Resend Verification Email
          </SubmitButton>
          {!!errors.resendVerificationEmailFailed && (
            <FormHelperText error sx={{ alignSelf: "flex-start" }}>
              {errors.resendVerificationEmailFailed}
            </FormHelperText>
          )}
          <TextualDivider>Or</TextualDivider>
          <Button variant="text" onClick={navigateToHome}>
            Return To Login
          </Button>
        </Stack>
      </Fade>
      <Fade in={status === "emailAlreadyVerified"} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={status === "emailAlreadyVerified" ? "flex" : "none"}
        >
          <Header
            disableCompanyIdentity
            title="Email verification failed"
            subtitle="You have already verified your email. Use your credentials to log in"
          />
          <Button variant="text" onClick={navigateToHome}>
            Return To Login
          </Button>
        </Stack>
      </Fade>
    </Container>
  );
};

export default EmailVerification;
